
// import React, { Component } from 'react';
import './AP css.css'
import React, { useState } from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import Scroll from 'react-scroll'
import ap from './images/ap.png'

const ScrollLink = Scroll.ScrollLink;

const Slidenavbar = (props) => {
 
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);


  return (
    <div >
      <Navbar fixed="top" style={{ fontWeight: 'bold'}}  light expand="md" class="nav nav-tabs" role="tablist">
        <NavbarBrand href="/home" className="navbarbrand" ><img src={ap} height="30" width="53" alt=""/></NavbarBrand>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav  className="ml-auto " navbar>
            <NavItem>
              <NavLink ml-5 href="/home"style={{ fontSize: '1.2em'}}>Home</NavLink>
            </NavItem>

            <NavItem  >
                <NavLink className="ml-20" ml-5  href="/Branding" style={{ fontSize: '1.2em'}}>Branding</NavLink>
            </NavItem>
            <NavItem  >
                <NavLink className="ml-20" ml-5  href="/about" style={{ fontSize: '1.2em'}}>About</NavLink>
            </NavItem>
            <ScrollLink></ScrollLink>
           
        <NavItem  >
        <NavLink ml-5 href="#contact" style={{ fontSize: '1.2em'}}>Contact</NavLink>
      </NavItem>
     
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
}

export default Slidenavbar;